module.exports = {
    'Environment': 'Development',
    'API_BASE': '',
    'DOMAIN': 'viralstyle.com',
    'CLIENT_SUBDOMAIN': 'client-admin.stg',

    'OAuth_Required': true,
    'OAuth': {
        'grant_type': 'client_credentials',
        'client_id': 'frontend',
        'client_secret': 'frontend',
        'scope': 'public'
    },
    'ImagesUrl': 'assets/customer-ui/images',
    'TemplatesUrl': '/assets/customer-ui/templates',

    'Marketplace': {
        'MIN_PRICE': 0,
        'MAX_PRICE': 80,
        'LIMIT': 50
    },

    // Payments
    'Amazon': {
        'sandbox': true,
        'clientID': 'amzn1.application-oa2-client.3e40f479b3b74c9f831e5954ca0d88b8',
        'sellerID': 'ACM4MDNPXTZGE'
    },
    'PayPal': {
        'merchantID': 'matt-facilitator_api1.obscurelogic.com',
        'environment': 'sandbox'
    },

    'Analytics': {
        'enabled': true,
        'domain': 'viral-tees.app',
        'googleID': 'UA-73140867-1',
        'facebookPixelID': '581319138682569',
        'facebookAcquisitionID': 'ACQ581319138682569',
        'googleRetargetID': 123456789,
        'googleAdwordsID': 112233445
    },

    'ClientAnalytics': {
        'enabled': true
    },

    'SmartyStreets': {
        'enabled': false,
        'ID': '18226769276996505'
    },

    'SocialAuth': {
        'facebookID': '362850150556822'
    },

    'ErrorReporting': {
        'sentryURI': 'https://2c9e5ec753c042afac5288769ec12b25@app.getsentry.com/74360', // TODO: Personal trial project, change to real project later
        'sentryConfig': {}
    },

    'VWO': {
        'id': 12345,
        'enabled': true
    },

    'GTM_ID': 'GTM-KTS5SHQ',

    'GOOGLE_PLACES_API_KEY': 'AIzaSyANmRdeyE6Y1fb7OF4XZ8SmACOjB4YI2ug',

    'GOOGLE_RECAPTCHA_SITEKEY': '6Ldd70wUAAAAAHAZL5V9j4iF4WhRDTCuDZzeo3k4'
};



// WEBPACK FOOTER //
// ./source/client/config.staging-no-cdn.js